import { createContext } from 'react';

export const ActivitySelectedContext = createContext(null);
